export const UPDATE_STORE = '2000_UPDATE_STORE';
export const UPDATE_CERTAIN_NAME = '2000_UPDATE_CERTAIN_NAME';
export const UPDATE_PET_SELECTED_BTN = '2000_UPDATE_PET_SELECTED_BTN';
export const UPDATE_PET_DROPDOWN_BREED = '2000_UPDATE_PET_SELECTED_BTN';
export const DELETE_CERTAIN_PET_DATA = 'DELETE_CERTAIN_PET_DATA';
export const UPDATE_INITIAL_PET_DATA = 'DELETE_CERTAIN_PET_DATA';
